// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/approval_task_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BusinessProcess } from "../../bfftypes/v1/approval_flow_type_pb";
import { file_bfftypes_v1_approval_flow_type } from "../../bfftypes/v1/approval_flow_type_pb";
import type { BiddingApprovalStageApprovers, BiddingApprovalState } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/approval_task_model.proto.
 */
export const file_bffuser_v1_approval_task_model: GenFile = /*@__PURE__*/
  fileDesc("CiRiZmZ1c2VyL3YxL2FwcHJvdmFsX3Rhc2tfbW9kZWwucHJvdG8SCmJmZnVzZXIudjEi2gMKDEFwcHJvdmFsVGFzaxIKCgJpZBgBIAEoCRI2ChBidXNpbmVzc19wcm9jZXNzGAIgASgOMhwuYmZmdHlwZXMudjEuQnVzaW5lc3NQcm9jZXNzEjgKDmFwcHJvdmFsX3N0YXRlGAMgASgOMiAuYmZmdXNlci52MS5CaWRkaW5nQXBwcm92YWxTdGF0ZRImCgt0YXJnZXRfZGF0ZRgEIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSEgoKaXRlbV9jb3VudBgFIAEoBRIZCgxyZXF1ZXN0ZWRfYnkYBiABKAlIAIgBARI1CgxyZXF1ZXN0ZWRfYXQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESGAoLYXBwcm92ZWRfYnkYCCABKAlIAogBARIuCgp1cGRhdGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBJCCg9zdGFnZV9hcHByb3ZlcnMYCiADKAsyKS5iZmZ1c2VyLnYxLkJpZGRpbmdBcHByb3ZhbFN0YWdlQXBwcm92ZXJzQg8KDV9yZXF1ZXN0ZWRfYnlCDwoNX3JlcXVlc3RlZF9hdEIOCgxfYXBwcm92ZWRfYnlCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_approval_flow_type, file_bffuser_v1_bidding_common_model, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * ApprovalTask は承認案件一覧 (= 画面 /admin/approval-tasks) の 1 行。
 *
 * BFF が複数 backend の承認軸を持つ集約 (= spot の SpotBidApprovalRequest /
 * intraday の IntradayOrder / block の BlockBidApprovalRequest) を fan-out して
 * 1 つの画面向け projection に束ねた read-only DTO。 承認/差戻しの操作は business_process に応じて既存の
 * BiddingSpotService / BiddingIntradayService / BiddingBlockService の
 * Transition RPC を frontend が呼ぶ (= 本 service には mutation を持たせない)。
 *
 * 業務プロセスは spot / intraday / block 入札に対応 (= 他プロセスは順次)。
 * approval_state は PENDING / APPROVED / REJECTED のみ載る (= 申請済の案件)。
 *
 * @generated from message bffuser.v1.ApprovalTask
 */
export type ApprovalTask = Message<"bffuser.v1.ApprovalTask"> & {
  /**
   * 元案件の id (= business_process に対応する Transition RPC の対象 id)。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 業務プロセス (= BUSINESS_PROCESS_SPOT_BID / BUSINESS_PROCESS_INTRADAY_BID /
   * BUSINESS_PROCESS_BLOCK_BID)。
   * frontend が承認/差戻しの遷移先 service を選ぶのに使う。
   *
   * @generated from field: bfftypes.v1.BusinessProcess business_process = 2;
   */
  businessProcess: BusinessProcess;

  /**
   * 承認軸の状態 (= 申請中 / 承認済 / 差戻し)。
   *
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 3;
   */
  approvalState: BiddingApprovalState;

  /**
   * 受渡日 (= 案件の識別補助、 一覧表示用)。
   *
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * 件数 (= spot は子入札数、 intraday は 1)。
   *
   * @generated from field: int32 item_count = 5;
   */
  itemCount: number;

  /**
   * 承認申請者 / 申請日時 (= 一覧は申請日時の降順、 申請者列)。
   *
   * @generated from field: optional string requested_by = 6;
   */
  requestedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp requested_at = 7;
   */
  requestedAt?: Timestamp;

  /**
   * 承認者 (= 承認済 / 差戻し済の場合に入る)。
   *
   * @generated from field: optional string approved_by = 8;
   */
  approvedBy?: string;

  /**
   * 楽観ロック基準値 (= 承認/差戻し Transition の expected_updated_at に直渡し)。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * 承認申請の時点で写した、 次の承認・差戻しを判定する段の承認者 (承認案件一覧の
   * 承認者でない人・申請者本人への注意表示に使う。 approval-tasks.md AC-APT-019a)。
   * spot / block は申請の写しをそのまま返す。 intraday は今の段の承認者
   * (IntradayOrderListItem.current_stage_approver_member_ids) を 1 行に載せ替える (area_code は
   * UNSPECIFIED、 stage_order は 0 = 一覧の項目に段数が無いため載せない)。 承認者 0 人なら空。
   *
   * @generated from field: repeated bffuser.v1.BiddingApprovalStageApprovers stage_approvers = 10;
   */
  stageApprovers: BiddingApprovalStageApprovers[];
};

/**
 * Describes the message bffuser.v1.ApprovalTask.
 * Use `create(ApprovalTaskSchema)` to create a new message.
 */
export const ApprovalTaskSchema: GenMessage<ApprovalTask> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_approval_task_model, 0);

